import Cookies from 'js-cookie';
import Commercial from './commercial';

class Cmp {

	constructor(options) {
		let defaults = {
			prebid: true
        };
		this.params = Object.assign({}, defaults, options || {});
        this.loadedVendors = {};
		this.start();
	}

	start() {

        /*
		if (typeof __nocmp !== 'undefined') {
			this.loadGoogleVendor(false);
			return;
		}*/

		// If CMP is not loaded check again after 1 second
		if (typeof __tcfapi === 'undefined') {

			window.setTimeout(() => {
				this.start();
			}, 1000);

			return;
		}

		var self = this;

		// Check consent
		__tcfapi('addEventListener', 2, function (tcData, success) {

			if (!success) {
				return;
			}

			if (tcData.eventStatus === 'useractioncomplete' || tcData.eventStatus === 'tcloaded') {

				var consents = tcData.purpose.consents;
				var legitimateInterests = tcData.purpose.legitimateInterests;

                gtag('consent', 'update', {
                    'ad_storage': consents[1] ? 'granted' : 'denied',
                    'ad_user_data': (consents[1] && consents[7]) ? 'granted' : 'denied',
                    'ad_personalization': (consents[3] && consents[4]) ? 'granted' : 'denied',
                    'analytics_storage': (consents[7] && consents[8] && consents[9] &&
                        consents[10]) ? 'granted' : 'denied',
                    'functionality_storage': consents[2] ? 'granted' : 'denied',
                    'personalization_storage': (consents[3] && consents[4]) ? 'granted' : 'denied',
                    'security_storage': consents[7] ? 'granted' : 'denied',
                });

                if (
                    !consents[1] ||
                    !(consents[7] && consents[8] && consents[9] && consents[10])
                ) {
                    gtag('set', 'url_passthrough', true);
                }

				/*
				1: Store and/or access information on a device
				2: Select basic ads
				3: Create a personalised ads profile
				4: Select personalised ads
				5: Create a personalised content profile
				6: Select personalised content
				7: Measure ad performance
				8: Measure content performance
				9: Apply market research to generate audience insights
				10: Develop and improve products
				*/

				var can_1 = consents['1'] ? 1 : 0;
				var can_2 = consents['2'] ? 1 : 0;
				var can_3 = consents['3'] ? 1 : 0;
				var can_4 = consents['4'] ? 1 : 0;
				var can_5 = consents['5'] ? 1 : 0;
				var can_6 = consents['6'] ? 1 : 0;
				var can_7 = consents['7'] ? 1 : 0;
				var can_8 = consents['8'] ? 1 : 0;
				var can_9 = consents['9'] ? 1 : 0;
				var can_10 = consents['10'] ? 1 : 0;

				var may_1 = legitimateInterests['1'] ? 1 : 0;
				var may_2 = legitimateInterests['2'] ? 1 : 0;
				var may_3 = legitimateInterests['3'] ? 1 : 0;
				var may_4 = legitimateInterests['4'] ? 1 : 0;
				var may_5 = legitimateInterests['5'] ? 1 : 0;
				var may_6 = legitimateInterests['6'] ? 1 : 0;
				var may_7 = legitimateInterests['7'] ? 1 : 0;
				var may_8 = legitimateInterests['8'] ? 1 : 0;
				var may_9 = legitimateInterests['9'] ? 1 : 0;
				var may_10 = legitimateInterests['10'] ? 1 : 0;

				// Store and/or access information on a device (Purpose 1)
				if (!can_1) {
                    self.loadGoogleVendor(false);
					return;
				}

				// Google Advertising Products
				// Action = create a new commercial.js module
				if (tcData.vendor.consents['755'] && tcData.vendor.legitimateInterests['755']) {
					if ((can_2 || may_2) && (can_7 || may_7) && (can_9 || may_9) && (can_10 || may_10)) {
						let personalized = can_3 && can_4;
						self.loadGoogleVendor(personalized);
                        console.log(tcData.eventStatus);
					}
				}

				// Taboola for Project agora id: 42
				// Action = Load vendor script
				if (tcData.vendor.consents['42']) {
				if (can_3 && can_9 && can_10) {
					// self.loadTaboolaVendor(tcData);
				}
				}

				// Neustar for P&G Vendor id: 577
				// Action = Declare function to window & load vendor script
				/*
						if (tcData.vendor.consents['577']) {
							if ((can_2 || may_2) && (can_3 || may_3) && (can_4 || may_4) && (can_5 || may_5) &&
								(can_6 || may_6) && (can_7 || may_7) && (can_8 || may_8) && (can_9 || may_9)) {
								self.loadPnGVendor(tcData);
							}
				}
				*/

				// Semasio for Tempo id: 84
				// Action = Load vendor pixel script
				/*
						if (tcData.vendor.consents['84']) {
							if (can_3 && can_9 && can_10) {
								self.loadTempoVendor(tcData);
							}
				}
				*/
				
				// Unilever Vendor id: 829
				// Action = load vendor script
				/*
				if (tcData.vendor.consents['829']) {
				if ((can_2 || may_2) && can_3 && can_4 && can_5 && can_6 && (can_7 || may_7) &&
					(can_8 || may_8) && can_9) {
					self.loadUnileverVendor();
				}
				}
				*/
    
			}
		});
	}

	loadGoogleVendor(personalized) {

        if (this.loadedVendors.google) {
            return;
        }

		new Commercial({
			loadScripts: true,
			personalized: personalized,
			prebid: this.params.prebid,
			membrana: this.params.membrana
		});

        this.loadedVendors.google = true;

        console.log('personalized:' + personalized);
	}

	loadTaboolaVendor(tcData) {

    if (typeof window.dfp_targeting.pagetype !== 'undefined') {
		var pageType = window.dfp_targeting.pagetype;
		var loadTaboola = pageType == 'story' || pageType == 'video' || pageType == 'gallery' || null;

		if (loadTaboola) {
			var script = document.createElement('script');
			script.src = 'https://agorahtag.tech/c/fosonline.js';
			script.async = true;
			document.head.append(script);
		}
		}
	}

	loadPnGVendor(tcData) {
		var GeoGdprApplies = tcData.gdprApplies ? 1 : 0;
		window.setUpAgknTag = function (tag) {
			tag.setBpId("dpggreece");
			if (typeof window.dfp_targeting.section !== 'undefined') {
				tag.setCat(window.dfp_targeting.section);
			}
			if (typeof window.dfp_targeting.category !== 'undefined') {
				tag.addEchoKeyValue("subcat", window.dfp_targeting.category);
			}
			tag.setGdpr(GeoGdprApplies);
			tag.setGdprConsent(tcData.tcString);
		}

		// P&G
		const png = document.createElement('script');
		png.src = "https://js.agkn.com/prod/v0/tag.js";
		png.async = true;
		document.head.appendChild(png);
	}

	loadTempoVendor(tcData) {
		try {
			var GeoGdprApplies = tcData.gdprApplies ? 1 : 0;
			var smoGDPRFlag = GeoGdprApplies;
			var smoGDPRConsentString = tcData.tcString;
			var smoRand = Math.random() * 100000000000000000;
			var smoTrSeq = (typeof (smoTrSeq) != "undefined") ? smoTrSeq + 1 : 0;
			var smoPrtKey = 'omdgr/1';
			var smoPUrl = escape(window != parent ? document.referrer : document.location.href);
			var smoIframe = window != parent ? '&nIframe=1' : '';
			var smoParams = '&sType=view&nCampaignId=1';
			var smoProto = (document.location.protocol == 'https:') ? "https:" : "http:";
			var smoTrUrl = smoProto + '//uip.semasio.net/' + smoPrtKey + '/info?gdpr=' + smoGDPRFlag + '&gdpr_consent=' + smoGDPRConsentString + '&_referrer=' + smoPUrl + smoParams + '&nJs=1&_ignore=' + smoRand + smoIframe;
			var smoTrImg = new Image(); smoTrImg.src = smoTrUrl;
		} catch (err) { }
  }
  
  loadUnileverVendor() {
		const unilever = document.createElement('script');
		// unilever.src = "https://cdn.domain.gr/services/vendors/unilever-dil-v1.js";
		unilever.async = true;
		document.head.appendChild(unilever);
	}

	repropmpt() {
		Cookies.remove('euconsent-v2', {
			path: '/',
			domain: '.' + location.host
		});

		__tcfapi('displayConsentUi', 2, function () { });
	}
}

export {
	Cmp as
		default
};
